import { toast } from "react-toastify";

export const updateWithToast = <T>(promise: Promise<T>) => {
  return toast.promise(promise, {
    pending: "Saving...",
    success: "Saved!",
    error: "Something went wrong.",
  });
};
